import styled, { css } from 'styled-components';
import { Button } from '@xingternal/button';
import { scale150, spaceM, xdlColorControlFillSecondary, xdlColorControlFillTertiary, xdlColorText, spaceXS, } from '@xingternal/tokens';
import { mediaSmallOrTiny } from '@xingternal/layout-tokens';
export const SettingsDropdownButton = styled(Button) `
  border-radius: ${scale150};
  padding: 3px ${spaceM};
  ${({ size }) => size === 'large' &&
    css `
      height: 58px;
    `}

  @media ${mediaSmallOrTiny} {
    padding: 0;
  }

  &:hover {
    background: ${xdlColorControlFillSecondary};
  }

  &:active {
    background-color: ${xdlColorControlFillTertiary};
    border-color: ${xdlColorControlFillTertiary};
    color: ${xdlColorText};
  }

  & span:first-child {
    margin-left: ${spaceXS};
    @media ${mediaSmallOrTiny} {
      display: none;
    }
  }
`;
//# sourceMappingURL=SettingsDropdown.styles.js.map